var map = {
	"./change.svg": 43151,
	"./close.svg": 63148,
	"./copy.svg": 3525,
	"./disconnect.svg": 10710,
	"./explorer.svg": 78913,
	"./home.svg": 3945,
	"./icon-arrow.svg": 51089,
	"./icon-conversion.svg": 49547,
	"./icon-ok.svg": 35686,
	"./icon-search.svg": 84814,
	"./icon-share.svg": 71820,
	"./icon-time.svg": 94375,
	"./icon-up.svg": 33442,
	"./img-empty.svg": 23002,
	"./loading.svg": 66859,
	"./more.svg": 54911,
	"./mytokens.svg": 47274,
	"./ranking.svg": 12782,
	"./referral.svg": 5948,
	"./rewards.svg": 49769,
	"./setting.svg": 22540,
	"./telegram.svg": 91068,
	"./timeH5svg.svg": 36489,
	"./twitter.svg": 43927,
	"./txns.svg": 92634,
	"./zoom.svg": 97867,
	"./zoomOut.svg": 49220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;